import { render, staticRenderFns } from "./ActionBaseDetails.vue?vue&type=template&id=af5184a0"
import script from "./ActionBaseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionBaseDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports